import { render } from "./tabDocument.vue?vue&type=template&id=7c25a070"
import script from "./tabDocument.vue?vue&type=script&lang=js"
export * from "./tabDocument.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__